module.exports = __webpack_public_path__ + "img/client_icon_02.afc3d913.png";